import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberGoogleScholar } from "./routeType";

const { key, getPath } = getApi("members.googleScholar.get");

type IExtractedRouteType =
  IMemberGoogleScholar["googleScholarDataSingleRetrieve"];

export type IGetMemberGoogleScholar = IPickSingleQuery<IExtractedRouteType>;

const getMemberGoogleScholar: Fetcher<
  IGetMemberGoogleScholar["response"],
  IGetMemberGoogleScholar["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetMemberGoogleScholar = createQuery({
  queryKey: [key],
  fetcher: getMemberGoogleScholar,
});
